import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../authentication/services/auth.service';
import { PermissionService } from '../../shared/services/permission.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    if (!localStorage.getItem('userPermissions')) {
      permissionService.loadUserPermissions().subscribe();
    }

    return true;
  }

  return router.navigate(['/auth/login'], {
    queryParams: {
      'redirect-url': state.url
    }
  });
};
